import {useState} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import {SaitamaAd} from '@adv-mt/advertising-publift'

export const SaitamaAdMultiformatStyled = ({className, id, isAlwaysNative, activeExperiments}) => {
  const [isNative, setNative] = useState(Boolean(isAlwaysNative))

  return (
    <div
      key={id}
      className={cx(className, {
        'mt-CardAd': isNative,
        'mt-CardBasic': isNative
      })}
    >
      <SaitamaAd
        id={id}
        onAdDisplayed={({displayDetails} = {}) => {
          const isNativeDisplayed = displayDetails?.size?.[0] <= 1
          if (!isAlwaysNative && isNative !== isNativeDisplayed) {
            setNative(isNativeDisplayed)
          }
        }}
        activeExperiments={activeExperiments}
      />
    </div>
  )
}

SaitamaAdMultiformatStyled.displayName = 'SaitamaAdMultiformatStyled'
SaitamaAdMultiformatStyled.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  isAlwaysNative: PropTypes.bool,
  activeExperiments: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.bool.isRequired
    })
  )
}
